export default "__VITE_ASSET__BbM493qZ__"